import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-fake-add-user',
  templateUrl: './fake-add-user.component.html',
  styleUrls: ['./fake-add-user.component.scss']
})
export class FakeAddUserComponent implements OnInit {

  public user = {
    email: null,
    password: null,
    passwordCheck: null
  };

  constructor(
    public activeModal: NgbActiveModal
  ) {
  }

  ngOnInit() {
  }

  add() {
    this.activeModal.close(this.user);
  }
}
